import * as Schema from "effect/Schema";
import { PositiveInt, TrimmedNonEmptyString, TrimmedString } from "./baseSchemas.ts";

export const SkillDetails = Schema.Struct({
  id: Schema.String,
  name: Schema.String,
  slug: Schema.String,
  description: Schema.String,
  body: Schema.String,
  scope: Schema.Literals(["global", "jurisdiction", "organization"]),
  category: Schema.NullOr(Schema.String),
  tags: Schema.Array(Schema.String),
  status: Schema.Literals(["active", "draft", "archived"]),
  version: PositiveInt,
  updatedAt: Schema.NullOr(Schema.String),
  canEdit: Schema.Boolean,
});
export type SkillDetails = typeof SkillDetails.Type;

/** Only content is editable. Scope, ownership, slug and status stay server-owned. */
export const SkillUpdate = Schema.Struct({
  expectedVersion: PositiveInt,
  name: TrimmedNonEmptyString.check(Schema.isMaxLength(120)),
  description: TrimmedNonEmptyString.check(Schema.isMaxLength(1_024)),
  body: TrimmedNonEmptyString.check(Schema.isMaxLength(60_000)),
  category: Schema.NullOr(TrimmedString.check(Schema.isMaxLength(128))),
  tags: Schema.Array(TrimmedNonEmptyString.check(Schema.isMaxLength(128))).check(
    Schema.isMaxLength(12),
  ),
});
export type SkillUpdate = typeof SkillUpdate.Type;
